/**
 * Created by PhpStorm on 06.06.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
'use strict';

angular.module('far.models.menuitem', [])
    .service('MenuItem', function ($log, $http) {
        var list = [],
            firstListQuery = true,
            listQueryProgress = false;

        Object.defineProperty(this, 'list', {
            get: function () {
                if (firstListQuery && !listQueryProgress) {
                    listQueryProgress = true;
                    $http.get(Routing.generate('api_get_menu_list'))
                        .then(function (response) {
                            response.data.forEach(function (item) {
                                item.selected = false;
                                list.push(item);
                            });

                            firstListQuery = false;
                            listQueryProgress = false;
                        })
                        .catch(function (response) {
                            $log.error(response);
                            listQueryProgress = false;
                        });
                }

                return list;
            }
        });

        this.new = function (data) {
            return new MenuItem(data);
        };

        this.get = function (routeId, callback) {
            var route = new MenuItem({
                sort: 500
            });

            if (routeId > 0) {
                $http.get(Routing.generate('api_get_menu', {item: routeId}))
                    .then(function (response) {
                        route.update(response.data);

                        if (typeof callback == 'function') {
                            callback(route);
                        }
                    }, function errorCallback(response) {
                        $log.error(response);
                    });
            }

            return route;
        };

        this.delete = function (route, callback) {
            return $http.delete(Routing.generate('api_delete_menu', {item: route.id}))
                .then(function () {
                    route = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        function MenuItem(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);
                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_put_menu', {item: this.id}) :
                                Routing.generate('api_post_menu');

                        var data = angular.merge({}, this);

                        if (angular.isObject(data.parent)) {
                            data.parent = data.parent.id;
                        }

                        return $http[method](url, data);
                    }
                }
            });
        }
    });